import type { FaireProductEntity } from "../../entity_types/product";

export const p_zcxs6hxgxs: FaireProductEntity = {
  token: "p_zcxs6hxgxs",
  type: "product",
  name: "Two Tone Star 18K Gold Plated Stainless Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/3d616a1b84dcf1472f9c41b0db2f0d9ab3ea642ff5e6f51fd9748e846b3bf086.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/258fd06d262612ba1e33d5d46809fcd6e7a578a22714a3abf00826ba855c4d80.jpeg",
    "https://cdn.faire.com/fastly/eecb1b24fcfd91fcc8dd89e7af892ba56ef7a8d4222a9e95919923a9c68fdbc2.jpeg",
    "https://cdn.faire.com/fastly/7ab893fea6550423795c53a446466d00927c07297cc8f7532f9920800ed26da4.jpeg"
  ],
  priceDollars: 7.69,
  description: "Type: Ring\nMaterial : Stainless steel ,18K gold plated\nSize : 7#Process: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 19.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:55.008Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
